<template>
  <div
    class="col-sm-12 col-lg-5 detail px-4 d-flex flex-row align-items-center"
  >
    <!-- <div class="col-sm-12 col-lg-5 mx-0 px-0 mobile-100 detail"> -->
    <div class="offset-md-1 m-2">
      <img
        src="@/assets/images/booker/Merci_hubert_by_oliverlist.png"
        alt="merci_booker"
        width="460px"
        class="d-none d-sm-block mx-auto"
      />
      <div></div>
      <div class="row d-flex justify-content-center mt-4 text-center">
        <div class="col-12">
          <h4 class="font-weight-bolder">
            {{ $t("lang.label.booker-login-get-meeting")
            }}<i class="icon icon-rocket ml-2"></i>
          </h4>
          <h6 class="my-3 font-weight-bold">
            {{ $t("lang.label.booker-login-join") }}
          </h6>
        </div>
        <div class="col-12 d-flex justify-content-center mb-3">
          <ul>
            <li class="ml-5 my-1 d-flex justify-content-start">
              <div>
                <i class="icon icon-calendar icon-feature"></i>
                <span class="mx-2"
                  ><h6>{{ $t("lang.label.booker-login-mission") }}</h6></span
                >
              </div>
            </li>

            <li class="ml-5 my-1 d-flex justify-content-start">
              <div>
                <i class="icon icon-fire icon-feature"></i>
                <span class="mx-2"
                  ><h6>{{ $t("lang.label.booker-login-commercial") }}</h6></span
                >
              </div>
            </li>
            <li class="ml-5 my-1 d-flex justify-content-start">
              <div>
                <i class="icon icon-briefcase icon-feature"></i>
                <span class="mx-2"
                  ><h6>
                    {{ $t("lang.label.booker-login-meeting") }}
                  </h6></span
                >
              </div>
            </li>
            <li class="ml-5 my-1">
              <div class= "d-flex justify-content-start">
                <div>
                  <i class="icon icon-money icon-feature"></i>
                </div>
                <div class="mr-4">
                  <small class="text-li">
                    {{ $t("lang.label.booker-login-remuneration") }}
                  </small>
                </div>
              </div>
            </li>
            <h6 class="mt-3 font-weight-bold">
              {{ $t("lang.label.booker-login-register") }}
            </h6>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
h4 {
  font-weight: 300;
}
h6 {
  font-weight: 300;
}
.logooliver {
  width: 120px;
}
.calendar {
  width: 240px;
}
.border border-dark {
  border: 2px solid red;
}

.text-li {
  font-size: 1rem;        /* Similar al h6 pero más controlado */
  font-weight: 300;       /* Un poco más grueso como el h6 */
  line-height: 1.4;
}

.icon-feature {
  width: 28px;
  font-weight: bold;
}
</style>
